export default __webpack_public_path__ + "static/media/pdf.b647d557.svg";